module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bd9133aa1169171ed2c1fc1bb37dc0ca.png";